import { render, staticRenderFns } from "./verArticulo.vue?vue&type=template&id=01a4ac90"
import script from "./verArticulo.vue?vue&type=script&lang=js"
export * from "./verArticulo.vue?vue&type=script&lang=js"
import style0 from "./verArticulo.vue?vue&type=style&index=0&id=01a4ac90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports